import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, Eye, EyeOff, KeyRound, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const field = "w-full bg-white border border-[var(--mf-line)] px-4 py-3 focus:border-[var(--mf-red)] transition-colors";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 6) { setError("Passwort muss mindestens 6 Zeichen haben."); return; }
    if (pw !== pw2) { setError("Die Passwörter stimmen nicht überein."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      setTimeout(() => navigate("/admin/login"), 2500);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--mf-mist)] p-6">
      <div className="w-full max-w-sm bg-white border border-[var(--mf-line)] p-8">
        <div className="font-head font-bold text-2xl mb-6">MF<span className="text-[var(--mf-red)]"> · </span>MED</div>
        {!token ? (
          <div>
            <p className="text-[var(--mf-ink)]">Der Link ist unvollständig.</p>
            <Link to="/admin/login" className="mf-cta-ghost mt-4 inline-flex">Zur Anmeldung</Link>
          </div>
        ) : done ? (
          <div data-testid="reset-success" className="text-center">
            <CheckCircle2 className="text-[var(--mf-red)] mx-auto" size={40} />
            <p className="mt-4 font-head font-semibold text-[var(--mf-ink)]">Passwort geändert</p>
            <p className="text-sm text-[var(--mf-grey)] mt-1">Sie werden zur Anmeldung weitergeleitet …</p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="reset-form">
            <span className="mf-eyebrow">Neues Passwort</span>
            <h1 className="font-head font-bold text-2xl tracking-tight mt-4 text-[var(--mf-ink)]">Passwort festlegen</h1>
            {error && <div data-testid="reset-error" className="mt-5 text-sm text-[var(--mf-red)] border border-[var(--mf-red)]/30 bg-[var(--mf-red)]/5 px-4 py-3">{error}</div>}
            <div className="mt-5 space-y-4">
              <div className="relative">
                <input data-testid="reset-password" type={show ? "text" : "password"} required className={field + " pr-12"} placeholder="Neues Passwort" value={pw} onChange={(e) => setPw(e.target.value)} />
                <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--mf-grey)]">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button>
              </div>
              <input data-testid="reset-password2" type={show ? "text" : "password"} required className={field} placeholder="Passwort wiederholen" value={pw2} onChange={(e) => setPw2(e.target.value)} />
              <button data-testid="reset-submit" disabled={loading} className="mf-cta w-full disabled:opacity-60">
                {loading ? <Loader2 size={18} className="animate-spin" /> : <KeyRound size={16} />} Passwort speichern
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
